import styled from "styled-components";
import {
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
	COLOR_TEXT_HIGHLIGHT,
} from "@website-builder/utilities-index";

export const FullWidthCtaWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const FullWidthCta = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	align-items: center;
	padding: 50px 0px;
	p {
		margin: 0px;
	}
`;

export const OneLineFullWidthCta = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	padding: 85px 10px;
	flex-flow: wrap;
	justify-content: center;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 10px;
	}
`;

export const OneLineHeader = styled.div`
	margin: 20px 30px;
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 28px;
	text-align: center;
	color: ${(props) => props.fontColor || COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 245px;
		font-size: 24px;
	}
`;

export const Header = styled.h2`
	width: 700px;
	font-size: 28px;
	font-weight: ${FONT_WT_MEDIUM};
	line-height: 28px;
	text-align: center;
	margin: 0px;
	color: ${(props) => props.fontColor || COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 245px;
		font-size: 24px;
	}
`;

export const Description = styled.span`
	width: 650px;
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	text-align: center;
	margin-top: 20px;
	color: ${(props) => props.fontColor || COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		width: 240px;
		font-size: 16px;
		line-height: 1.69;
	}
`;
export const CTAWrapper = styled.span`
	margin-top: 25px;
	button {
		padding-left: 50px;
		padding-right: 50px;

		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			padding-left: 30px;
			padding-right: 30px;
		}
	}
`;

export const OneLineCTAWrapper = styled.span`
	button {
		padding-left: 50px;
		padding-right: 50px;

		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			padding-left: 30px;
			padding-right: 30px;
		}
	}
`;
